import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal } from "@/components/site/Motion";

export default function FAQ({ content }) {
  const f = content?.faq || {};
  const items = f.items || [];
  if (!items.length) return null;

  return (
    <section id="ayuda" className="px-6 md:px-12 lg:px-24 py-24 md:py-32 border-t border-border">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <h4 className="font-sans text-sm tracking-[0.2em] uppercase text-faint mb-4">Preguntas frecuentes</h4>
            <h2 className="font-serif text-4xl md:text-6xl tracking-tight text-ink leading-[1.05]">{f.heading}</h2>
            {f.subtitle && <p className="font-sans text-base md:text-lg text-subtle mt-6 max-w-md">{f.subtitle}</p>}
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible defaultValue="faq-0" className="w-full border-t border-border">
              {items.map((it, i) => (
                <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-border">
                  <AccordionTrigger className="py-6 text-left hover:no-underline group [&>svg]:hidden">
                    <span className="flex items-start gap-5 pr-6">
                      <span className="font-sans text-sm text-faint mt-1.5 tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                      <span className="font-serif text-xl md:text-2xl text-ink leading-snug group-hover:text-subtle transition-colors duration-300">{it.q}</span>
                    </span>
                    <span className="ml-auto mt-2 shrink-0 w-6 h-6 relative">
                      <span className="absolute top-1/2 left-0 w-full h-px bg-ink -translate-y-1/2" />
                      <span className="absolute left-1/2 top-0 h-full w-px bg-ink -translate-x-1/2 transition-transform duration-300 group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0" />
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-8 pl-[52px] pr-10">
                    <p data-testid={`faq-answer-${i}`} className="font-sans text-base text-subtle leading-relaxed">{it.a}</p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
